<input #audioFile type="file" accept="audio/*" (change)="readAudio(audioFile.files!)"/>
<button type="button" (click)="audioFile.click()" i18n-title title="Upload or record audio" i18n>🎙️</button>
